import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from './entity';

@JsonObject('Client')
export class Client extends Entity {
  @JsonProperty('name', String)
  public name?: string = undefined;
  @JsonProperty('locationId', String)
  public locationId?: string = undefined;
  @JsonProperty('location', String)
  public location?: string = undefined;
}
